import * as Sentry from "@sentry/react";
import {
  MutationCache,
  QueryCache,
  QueryClient,
  UseMutationOptions,
  UseQueryOptions,
} from "@tanstack/react-query";
import { AxiosError } from "axios";

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      console.error("react-query error", error, {
        key: JSON.stringify(query.queryKey || "unknown"),
        type: "query",
      });
      Sentry.captureException(error, {
        tags: {
          queryKey: JSON.stringify(query.queryKey),
          component: "ReactQuery",
        },
      });
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, mutation) => {
      console.error("react-query mutation error", error, {
        variables: JSON.stringify(mutation || {}),
        type: "mutation",
      });
      Sentry.captureException(error, {
        tags: {
          component: "ReactQueryMutation",
        },
      });
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 60000,
      retry: false,
    },
  },
});

export type ExtractFnReturnType<FnType extends (...args: any) => any> = Awaited<ReturnType<FnType>>;

export type QueryConfig<QueryFnType extends (...args: any) => any> = Omit<
  UseQueryOptions<ExtractFnReturnType<QueryFnType>>,
  "queryKey" | "queryFn"
>;

export type MutationConfig<MutationFnType extends (...args: any) => any> = UseMutationOptions<
  ExtractFnReturnType<MutationFnType>,
  AxiosError,
  Parameters<MutationFnType>[0]
>;
